import { render, staticRenderFns } from "./digitalSourceItem.vue?vue&type=template&id=716ff8df&scoped=true&"
import script from "./digitalSourceItem.vue?vue&type=script&lang=js&"
export * from "./digitalSourceItem.vue?vue&type=script&lang=js&"
import style0 from "./digitalSourceItem.vue?vue&type=style&index=0&id=716ff8df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ff8df",
  null
  
)

export default component.exports